import React from "react";
import { Link } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { ArrowRight, Truck } from "lucide-react";
import { PageMeta } from "@/components/PageMeta";
import { CtaBand } from "@/components/CtaBand";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { SERVICES, EXTRA_SERVICES, BRAND } from "@/config/brand";

export default function Services() {
    const all = [...SERVICES, ...EXTRA_SERVICES];
    return (
        <div>
            <PageMeta title="Removals Services in London — YS Removals" description="House removals, flat removals, office moves, man and van and more — across London." canonical={`https://${BRAND.domain}/services`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Services" }]} />
                    <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight font-heading">Our removals services</h1>
                    <p className="mt-3 text-white/85 max-w-2xl">Pick the service that fits your job — from full house moves to a single item delivery.</p>
                </div>
            </section>
            <section className="container-ys section grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {all.map((s) => {
                    const Icon = LucideIcons[s.icon] || Truck;
                    return (
                        <Link key={s.slug} to={`/services/${s.slug}`} className="group rounded-xl bg-white border border-[#17252D]/10 p-5 hover:border-[#001B3D]/40 hover:shadow-[0_10px_30px_rgba(23,37,45,0.10)] transition-[box-shadow,border-color] duration-200">
                            <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#001B3D]/10 text-[#001B3D]"><Icon className="h-5 w-5" strokeWidth={1.75} /></span>
                            <h2 className="mt-4 text-lg font-heading font-semibold">{s.title}</h2>
                            <p className="mt-1 text-sm text-[#17252D]/75">{s.short}</p>
                            <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#001B3D]">Learn more <ArrowRight className="h-4 w-4" /></span>
                        </Link>
                    );
                })}
            </section>
            <CtaBand subtitle="Not sure which service you need? Tell us about the job and we’ll help." />
        </div>
    );
}
